import store from "../redux/store.ts";
import { apiCampaign } from "../api/campaign/apiCampaign";

import { notifyError } from "shared/errors/notificate.ts";
import { apiRTK, Tag } from "api/api-rtk";
import { addCampaignToCache } from "features/campaigns/api.ts";
import { campaignUtils } from "features/campaigns/index.ts";

export const refetchCampaigns = () =>
  store.dispatch(apiRTK.util.invalidateTags([Tag.Campaign]));

export const campaign = {
  changeUpdateCampaignController(value) {
    store.dispatch({
      type: "UPDATE_CAMPAIGN_CONTROLLER",
      payload: {
        updateCampaignController: value,
      },
    });
  },

  async updateCampaign(data) {
    campaign.changeUpdateCampaignController(true);
    try {
      const response = await apiCampaign.updateCampaign(data);

      addCampaignToCache(response.data, store.dispatch);

      store.dispatch(campaignUtils.refetchList());

      return response;
    } catch (error) {
      notifyError(error);
    } finally {
      campaign.changeUpdateCampaignController(false);
    }
  },
};
